import { Paper, Typography, Box, Button, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PetLicenseAcknowledgement = ({
  applicationDetails,
  applicationNumber,
  basePath,
  totalAmountPayable,
  totalAmountWithoutTax,
  totalTaxAmount
}) => {
  const navigate = useNavigate();

  return (
    <Paper
      sx={{
        borderRadius: 2,
        boxShadow: 3,
        p: { xs: 2, sm: 3, md: 4 },
        maxWidth: '100%'
      }}
    >
      <Typography
        variant="h4"
        sx={{
          mb: 3,
          textAlign: 'center',
          fontWeight: 600,
          color: 'primary.main'
        }}
      >
        Payment Acknowledgement
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        Hello <strong>{applicationDetails?.userName}</strong>,
      </Typography>

      <Box sx={{ mb: 2 }}>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Your payment of <strong>${totalAmountPayable}</strong> for Application{' '}
          <strong>#{applicationNumber}</strong> has been received, including{' '}
          <strong>${totalAmountWithoutTax}</strong> for the Pet License
          application and <strong>${totalTaxAmount}</strong> for online
          convenience fees.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          It will be processed shortly. We will keep you posted on the status of
          your application through email.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Please visit our website to get details on next steps.
        </Typography>
      </Box>

      <Typography variant="body1" sx={{ mb: 2 }}>
        If you have any further questions, please contact us at{' '}
        <Link
          href="mailto:HealthorAnimalControl@techgov.com"
          sx={{
            color: 'primary.main',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          HealthorAnimalControl@techgov.com
        </Link>
        .
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Thank you,
        </Typography>
        <Typography variant="body1">
          Department of Health or Animal Control.
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(`${basePath}/application-list`)}
          sx={{
            px: 4,
            py: 1.5,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 500
          }}
        >
          View My Applications
        </Button>
      </Box>
    </Paper>
  );
};

export default PetLicenseAcknowledgement;
